exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/* Kludge while we figure out how to add the form-control ng-invalid classes directly to the nested day-picker input */\n.DayPickerInput.ng-invalid > input {\n  border-color: var(--color-danger);\n}\n", ""]);

